// extracted by mini-css-extract-plugin
export default {"Header":"alert-dialog-module__Header--EGZD2","HeaderItemStyle":"alert-dialog-module__HeaderItemStyle--YhHzj"};